import { KeycloakService } from 'keycloak-angular';
import { KeycloakRole } from '../../../models';
import {
  HygieneInspectionStatus,
  SearchableInspectionResponse,
} from '../../../shared/models';

export const generateChangeHygieneStatusMenuItems = (
  inspection: SearchableInspectionResponse,
  keycloakService: KeycloakService
): HygieneInspectionStatus[] => {
  const items: HygieneInspectionStatus[] = [];
  // if no hygiene data exists, return an empty list
  if (inspection.hygieneData === undefined || inspection.hygieneData === null) {
    return items;
  }
  const hygieneData = inspection.hygieneData;

  const isReviewer = keycloakService.isUserInRole(
    KeycloakRole.BACKOFFICE_REVIEWER_HYGIENE
  );
  const isPlanner = keycloakService.isUserInRole(
    KeycloakRole.BACKOFFICE_PLANNER
  );

  // WAITING_FOR_LAB, IN_REVIEW, COMPLETED -> IN_PROGRESS  -- By BACKOFFICE_REVIEWER_HYGIENE
  if (
    [
      HygieneInspectionStatus.WAITING_FOR_LAB,
      HygieneInspectionStatus.IN_REVIEW,
      HygieneInspectionStatus.COMPLETED,
    ].includes(hygieneData.status) &&
    (isReviewer || isPlanner)
  ) {
    items.push(HygieneInspectionStatus.IN_PROGRESS);
  }

  // IN_REVIEW -> COMPLETED  -- By BACKOFFICE_REVIEWER_HYGIENE
  if (hygieneData.status === HygieneInspectionStatus.IN_REVIEW && isReviewer) {
    items.push(HygieneInspectionStatus.COMPLETED);
  }

  // COMPLETED -> IN_REVIEW  -- By BACKOFFICE_REVIEWER_HYGIENE
  if (hygieneData.status === HygieneInspectionStatus.COMPLETED && isReviewer) {
    items.push(HygieneInspectionStatus.IN_REVIEW);
  }

  return items;
};
